module.exports = __webpack_public_path__ + "static/media/DFYuanBold-01.ae5abb03.svg";